
import React, { useEffect, useState } from 'react'
import BodyClassName from "react-body-classname"

import Loading from 'components/Loading'

import styles from './styles.module.scss'

const Sign = props => {
  const [isLoading, setIsLoading] = useState(false)
  const [request, setRequest] = useState(null)

  const { onSave } = props

  useEffect(() => {
    if (!request) setRequest(() => props.request)
  }, [props.request, request, setRequest])

  useEffect(() => {
    const _removeForm = () => {
      window.document.getElementById('documentForm').innerHTML = ''
      window.document.getElementById('documentForm__container').style.display = 'none'
      if (props.onClose) props.onClose()
    }
    window.onmessage = (e) => {
      if (e && e.data) {
        if (e.data?._clickedButton === 'close') _removeForm()
      }
    }
  }, []) // eslint-disable-line

  useEffect(() => {
    if (request) {
      setIsLoading(true)
      window.document.getElementById('documentForm__container').style.display = 'block'
      window.DocSpring.createVisualForm('#documentForm', {
        dataRequestId: request.requestId,
        tokenId: request.tokenId,
        tokenSecret: request.tokenSecret,
        domainVerification: false,
        showClearButton: true,
        focusFirstFieldOnLoad: true,
        footerHTML: (template) =>
          '<div class="dsp-footerLeft">' +
            '<button class="dsp-button dsp-primary" onclick="window.parent.postMessage({_clickedButton: \'close\'}, \'*\')">Close</button>' +
          '</div>' +
          '<div class="dsp-footerRight">' +
            '&nbsp;' +
          '</div>' +
          '<style>.dsp-form { border-left: 1px solid #ddd; border-right: 1px solid #ddd; }</style>',

        onLoad: _onFormLoad,
        onSave: data => {
          window.DocSpring.closeModal()
          if (onSave) onSave(data)
        },
        onError: error => {
          console.error('[Callback] Error:', error)
        }
      })
    }
  }, [request, onSave])
  
  // Printable Doc

  const _onFormLoad = () => {
    setIsLoading(false)
  }

  // Layout

  let bodyClassName = ""
  if (request) bodyClassName = "docsign--on"

  return (
    <BodyClassName className={bodyClassName}>
      <>
        <div id="documentForm__container" className={styles.documentForm__container}>
          <div id="documentForm" className={styles.documentForm}></div>
        </div>
        {isLoading && <Loading />}
      </>
    </BodyClassName>
  )
}

export default Sign
